export enum TENANT_TYPE {
  ACKOSEO = "ackoSeo",
  ACKO_LABS = "ackoLabs"
}
